import { useT } from "../../i18n/I18nProvider";

export const ContactThanks = ({ onAgain }) => {
  const t = useT();

  return (
    <div
      className="min-h-[320px] md:min-h-[380px] flex flex-col justify-center"
      data-testid="contact-thanks"
    >
      <div className="overline mb-4 md:mb-6">
        {t("contact.thanks.overline")}
      </div>
      <h2 className="font-display text-4xl md:text-6xl tracking-tightest">
        {t("contact.thanks.title1")}
        <br />
        <span className="font-editorial text-ink-700">
          {t("contact.thanks.titleEditorial")}
        </span>
        {t("contact.thanks.titleEnd")}
      </h2>
      <p className="mt-5 md:mt-6 text-[14px] md:text-[15px] text-ink-500 max-w-lg leading-relaxed">
        {t("contact.thanks.paragraph")}
      </p>
      <button
        className="btn-ghost mt-8 md:mt-10 w-fit"
        onClick={onAgain}
        data-testid="contact-send-again"
      >
        {t("contact.thanks.again")}
      </button>
    </div>
  );
};
